module.exports = __webpack_public_path__ + "static/img/pro3.6c1c3de4.jpg";